import React from 'react';
import { Row, Col  } from "react-bootstrap"
import Knob from './lib/knob'
import FuncPlot from './lib/funcplot';
import NumberInput from './lib/numberinput';

class RSpline extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: []}
    this.nr = this.props.def.nr;
    this.seedId = 'waveseed_'+this.nr;
    this.stepsId = 'wavesteps_'+this.nr;
    this.seed = { id: this.seedId, type: 'spinner', label: 'seed', size:3, min: 1, max: 100000, step: 1, defval:this.props.def.defaultSeed };
    this.steps = { id: this.stepsId, type: 'knob', label: 'steps', min: 4, max: 32, step: 1, defval:10 };
    this.trig = false;
    this.props.def.changeValue = this.setValue.bind(this);
    let self = this;
    this.components = {
      [self.seedId]: self.seed,
      [self.stepsId]: self.steps,
    }
    Object.values(this.components).forEach( component => component.tooltip=this.computeTooltip(component));
  }

  computeTooltip(elem) {
    return (elem.tooltip?elem.tooltip:'')
      + (elem.midictrl?' ctrl:'+elem.midictrl:'')
      + (this.props.def.osc? ' osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+elem.id:'')
  }

  async onStart() {
    console.log("rspline start");
    this.cs = this.props.cs;
    await this.fetchTable();
  }
  
  setValue(val) {
    Object.keys(val).forEach(key => {
      this.components[key].changeValue(val[key]);
    });
  }
 
  async fetchTable() {
     if(!this.cs) return;
     if(this.tbl === undefined) this.tbl = await this.cs.getChannel("s"+ this.nr);
     console.log(this.tbl);
     const fn = await this.cs.getTable(this.tbl);
     this.setState({ data: fn });
  }
 
  onChange(id,val) {
    this.props.onChange(this.props.def.id, { [id]:val });
    let obj = {};
    obj[id] = val;
    this.setState( obj );
    setTimeout( () => this.fetchTable(), 500);
  }

  render() {
    return (
      <Col className="patcol">
         <Row noGutters>
           <Col className="patlabel">{'wave'+this.props.def.nr}</Col>
         </Row>
         <Row noGutters>
           <Knob def={this.steps} key={this.steps.id} onChange={this.onChange.bind(this)}/>
         </Row>
         <Row noGutters>
           <NumberInput def={this.seed} key={this.seed.id} onChange={this.onChange.bind(this)}/>
         </Row>
         <Row><Col>&nbsp; </Col></Row>
         <Row noGutters>
           <FuncPlot w={this.props.def.vw} h={this.props.def.vh} data={this.state.data}/>
         </Row>
      </Col>
    )
  }

}

export default RSpline;
